import GridChart from "../../../components/Chart/GridChart";

const restaurantCharts = [
  { type: "bar", method: "restaurant.sales" },
  { type: "pie", method: "restaurant.by_category" },
];

const RestaurantDash = () => {
  return <GridChart charts={restaurantCharts} />;
};

export default RestaurantDash;
